@let showPersistenceType = wlConfigService.showFeature("persistenceType");
<div class="slip-wrapper">
  <h1>Betslip Settings</h1>
  <form [formGroup]="form" (submit)="handleSubmit()" class="slip-panel-content">
    <!--    {{ quickBetAmounts.errors | json }}-->
    @for (each of slipSettings; track each) {
      <div [class.hidden]="each.title === 'Persistence Type' && !showPersistenceType" class="slip-setting">
        <label>{{ each.title }}</label>
        <mat-divider></mat-divider>
        <mat-radio-group required [formControlName]="each.accessor">
          @for (every of each.options; track every) {
            <mat-radio-button color="primary" [value]="every.value">{{ every.label }}</mat-radio-button>
          }
        </mat-radio-group>
      </div>
    }
    <div class="stake-setting">
      <div class="stake-inputs" formArrayName="quickBetAmounts">
        @for (each of quickBetAmounts.controls; track $index) {
          @if (isEditingStake) {
            <input
              [ngClass]="{
                'invalid-stake-input': each.errors?.['min'] || (each.errors?.['required'] && each.touched) || each.errors?.['invalidCompactNotation'],
              }"
              [formControlName]="$index" />
          } @else if (each.value) {
            <button
              class="stake-btn"
              [disabled]="openBetsLoading$ | async"
              type="button"
              [color]="defaultStake?.value === each.value ? 'accent' : 'primary'"
              mat-raised-button
              (click)="setDefaultStake(each.value)">
              {{ each.value }}
            </button>
          }
        }
        <button
                class="edit-btn"
          mat-stroked-button
          type="button"
          (click)="isEditingStake = !isEditingStake"
          [disabled]="(isEditingStake && quickBetAmounts.hasError('required')) || !quickBetAmounts.controls.length || (openBetsLoading$ | async)">
          <mat-icon>{{ isEditingStake ? "check" : "edit" }}</mat-icon>
          {{ isEditingStake ? "Set" : "Edit" }}
        </button>
      </div>
      @if (quickBetAmounts.errors) {
        @for (error of quickBetAmounts.errors | keyvalue; track error) {
          @if (error?.key === "min") {
            <span class="stake-error">Value must be greater than zero.</span>
          }
          @if (error?.key === "required" && quickBetAmounts.touched) {
            <span class="stake-error">Stake fields can't be empty</span>
          }
          @if (error?.key === "invalidCompactNotation") {
            <span class="stake-error">Invalid compact notation</span>
          }
        }
      }
      @if (defaultStake?.hasError("required")) {
        <span class="stake-error">Please set default stake for one click betting</span>
      }
      <button
        mat-raised-button
        type="submit"
        class="stake-save-btn"
        [disabled]="form.invalid || !quickBetAmounts.controls.length || (openBetsLoading$ | async)">
        Save
      </button>
    </div>
    @if (openBetsLoading$ | async) {
      <app-bp-overlay />
    }
  </form>
</div>
